var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "form",
    {
      staticClass: "nti-checkout-billing",
      attrs: { id: "checkoutform", method: "post", action: _vm.action },
    },
    [
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.conditions,
            expression: "conditions",
          },
        ],
        attrs: { type: "hidden", name: "conditions" },
        domProps: { value: _vm.conditions },
        on: {
          input: function ($event) {
            if ($event.target.composing) return
            _vm.conditions = $event.target.value
          },
        },
      }),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.newsletter,
            expression: "newsletter",
          },
        ],
        attrs: { type: "hidden", name: "newsletter" },
        domProps: { value: _vm.newsletter },
        on: {
          input: function ($event) {
            if ($event.target.composing) return
            _vm.newsletter = $event.target.value
          },
        },
      }),
      _vm._v(" "),
      _c(
        "section",
        { staticClass: "nti-checkout-billing__invoice-information" },
        [
          _c("h1", { staticClass: "nti-webshop-checkout__title" }, [
            _vm._v(_vm._s(_vm.label.invoiceHeader)),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "nti-webshop-checkout__title-paragraph" }, [
            _vm._v(_vm._s(_vm.verifyLabel("paymentInfoSubTitleLabel"))),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "nti-checkout-billing__section-wrapper" },
            [
              _vm.renderMobile
                ? [
                    _c("FormBase", {
                      staticClass: "nti-checkout-billing__section-wrapper",
                      attrs: {
                        label: _vm.label,
                        form: _vm.mobileCheckoutForm,
                        displayValidationResult: _vm.displayValidationResult,
                      },
                    }),
                  ]
                : _vm._e(),
              _vm._v(" "),
              _vm.renderDesktop
                ? [
                    _c("FormBase", {
                      staticClass: "nti-checkout-billing__section-wrapper",
                      attrs: {
                        label: _vm.label,
                        form: _vm.invoiceForm,
                        displayValidationResult: _vm.displayValidationResult,
                      },
                    }),
                  ]
                : _vm._e(),
              _vm._v(" "),
              _c(
                "section",
                { staticClass: "nti-checkout-billing__section__bottom" },
                [
                  _c(
                    "article",
                    { staticClass: "nti-checkout-billing__checkbox-container" },
                    [
                      _c(
                        "label",
                        {
                          staticClass:
                            "custom-control custom-checkbox nti-checkout-billing__checkbox",
                        },
                        [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.useAlternateDeliveryAddress,
                                expression: "useAlternateDeliveryAddress",
                              },
                            ],
                            staticClass: "form-control custom-control-input",
                            attrs: {
                              type: "checkbox",
                              name: "UseOtherInvoice",
                              value: "true",
                              required: "required",
                            },
                            domProps: {
                              checked: Array.isArray(
                                _vm.useAlternateDeliveryAddress
                              )
                                ? _vm._i(
                                    _vm.useAlternateDeliveryAddress,
                                    "true"
                                  ) > -1
                                : _vm.useAlternateDeliveryAddress,
                            },
                            on: {
                              change: function ($event) {
                                var $$a = _vm.useAlternateDeliveryAddress,
                                  $$el = $event.target,
                                  $$c = $$el.checked ? true : false
                                if (Array.isArray($$a)) {
                                  var $$v = "true",
                                    $$i = _vm._i($$a, $$v)
                                  if ($$el.checked) {
                                    $$i < 0 &&
                                      (_vm.useAlternateDeliveryAddress =
                                        $$a.concat([$$v]))
                                  } else {
                                    $$i > -1 &&
                                      (_vm.useAlternateDeliveryAddress = $$a
                                        .slice(0, $$i)
                                        .concat($$a.slice($$i + 1)))
                                  }
                                } else {
                                  _vm.useAlternateDeliveryAddress = $$c
                                }
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c("span", {
                            staticClass: "custom-control-indicator",
                          }),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              staticClass:
                                "nti-checkout-billing__checkbox-label",
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.verifyLabel("useOtherBillingAddressLabel")
                                )
                              ),
                            ]
                          ),
                        ]
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _vm.showAlternateParticipantInputCheckbox
                    ? [
                        _c(
                          "article",
                          {
                            staticClass:
                              "nti-checkout-billing__checkbox-container",
                          },
                          [
                            _c(
                              "label",
                              {
                                staticClass:
                                  "custom-control custom-checkbox nti-checkout-billing__checkbox",
                              },
                              [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.alternateParticipant,
                                      expression: "alternateParticipant",
                                    },
                                  ],
                                  staticClass:
                                    "form-control custom-control-input",
                                  attrs: {
                                    type: "checkbox",
                                    name: "DifferentParticipantThanBilling",
                                  },
                                  domProps: {
                                    checked: Array.isArray(
                                      _vm.alternateParticipant
                                    )
                                      ? _vm._i(_vm.alternateParticipant, null) >
                                        -1
                                      : _vm.alternateParticipant,
                                  },
                                  on: {
                                    change: function ($event) {
                                      var $$a = _vm.alternateParticipant,
                                        $$el = $event.target,
                                        $$c = $$el.checked ? true : false
                                      if (Array.isArray($$a)) {
                                        var $$v = null,
                                          $$i = _vm._i($$a, $$v)
                                        if ($$el.checked) {
                                          $$i < 0 &&
                                            (_vm.alternateParticipant =
                                              $$a.concat([$$v]))
                                        } else {
                                          $$i > -1 &&
                                            (_vm.alternateParticipant = $$a
                                              .slice(0, $$i)
                                              .concat($$a.slice($$i + 1)))
                                        }
                                      } else {
                                        _vm.alternateParticipant = $$c
                                      }
                                    },
                                  },
                                }),
                                _vm._v(" "),
                                _c("span", {
                                  staticClass: "custom-control-indicator",
                                }),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "nti-checkout-billing__checkbox-label",
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.verifyLabel("alternateParticipant")
                                      )
                                    ),
                                  ]
                                ),
                              ]
                            ),
                          ]
                        ),
                      ]
                    : _vm._e(),
                ],
                2
              ),
            ],
            2
          ),
        ]
      ),
      _vm._v(" "),
      _vm.useAlternateDeliveryAddress
        ? _c(
            "section",
            { staticClass: "nti-checkout-billing__delivery-information" },
            [
              _c("h1", { staticClass: "nti-webshop-checkout__title" }, [
                _vm._v(
                  _vm._s(_vm.verifyLabel("otherBillingAddressTitleLabel"))
                ),
              ]),
              _vm._v(" "),
              _c(
                "p",
                { staticClass: "nti-webshop-checkout__title-paragraph" },
                [
                  _vm._v(
                    _vm._s(_vm.verifyLabel("otherBillingAddressSubTitleLabel"))
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "nti-checkout-billing__section-wrapper" },
                [
                  _c("FormBase", {
                    staticClass: "nti-checkout-billing__section-wrapper",
                    attrs: {
                      label: _vm.label,
                      form: _vm.deliveryForm,
                      displayValidationResult: _vm.displayValidationResult,
                    },
                  }),
                ],
                1
              ),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c("CheckoutCourseParticipants", {
        attrs: {
          formRaw: _vm.participantSignupForm,
          displayValidationResult: _vm.displayValidationResult,
          startDisabled: _vm.startAlternateParticipantFieldsDisabled,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }